import type { Theme } from '@mui/material'

interface GlobalClientSideBorderArgs {
  hasToolbarWithBorder?: boolean
}

export const tableFilterDesktopStyles = {
  globalClientSideBorder: (
    theme: Theme,
    { hasToolbarWithBorder }: GlobalClientSideBorderArgs = {}
  ) => ({
    border: `1px solid ${theme.palette.gray[12]}`,
    borderTopLeftRadius: hasToolbarWithBorder ? 0 : 0.5,
    borderTopRightRadius: hasToolbarWithBorder ? 0 : 0.5,
  }),
}
